import React from "react";
import Verification from "./Verification";
import Layout from "../../components/Layout";

const title = "Verify Your Identity";

export default async function action({ store }) {
  // Check if user is logged in
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: "/login" };
  }

  return {
    title,
    component: (
      <Layout>
        <Verification title={title} />
      </Layout>
    ),
  };
}
